<template>
  <div class="sms-hist">
    <h3>SMS 발송 이력 조회</h3>

    <div class="toolbar">
      <div class="tb-left">
        <input v-model="filters.phone" class="ed ed-sm" placeholder="전화번호" />
        <input v-model="filters.startDt" type="date" class="ed" />
        <span class="tilde">~</span>
        <input v-model="filters.endDt" type="date" class="ed" />
        <select v-model="filters.msgType" class="ed">
          <option value="">메시지 종류(전체)</option>
          <option value="L">LMS</option>
          <option value="S">SMS</option>
        </select>
        <select v-model="filters.sendResult" class="ed">
          <option value="">발송 결과(전체)</option>
          <option value="S">성공</option>
          <option value="F">실패</option>
        </select>
        <button class="btn btn-primary" @click="onSearch">조회</button>
      </div>
      <div class="tb-right">
        <button class="btn btn-primary" @click="downloadSearch">검색결과 다운로드</button>
        <button class="btn" @click="openDownload">기간 내 발송성공건 다운로드</button>
      </div>
    </div>

    <table class="grid">
      <thead>
        <tr>
          <th><input type="checkbox" :checked="allChecked" @change="toggleAll($event)" /></th>
          <th>이력 일시</th>
          <th>전화번호</th>
          <th>이름</th>
          <th>메시지 종류</th>
          <th>발송 결과</th>
          <th>use_yn</th>
          <th>del_yn</th>
          <th>request_id</th>
          <th>request_time</th>
          <th>status_code</th>
          <th>status_name</th>
          <th>발송 내용</th>
          <th>실패 내용</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in rows" :key="r.id">
          <td><input type="checkbox" v-model="sel[r.id]" /></td>
          <td>{{ r.regDt }}</td>
          <td>{{ r.telTo }}</td>
          <td>{{ r.name }}</td>
          <td>{{ msgLabel(r.msgType) }}</td>
          <td>
            <span v-if="resultLabel(r.sendYn) === '성공'" class="c-green">성공</span>
            <span v-else-if="resultLabel(r.sendYn) === '실패'" class="c-red">실패</span>
            <span v-else>-</span>
          </td>
          <td>{{ r.useYn }}</td>
          <td>{{ r.delYn }}</td>
          <td>{{ r.requestId }}</td>
          <td>{{ r.requestTime }}</td>
          <td>{{ r.statusCode }}</td>
          <td>{{ r.statusName }}</td>
          <td><button class="btn btn-xs" @click="openView('발송 내용', r.msgContent)">보기</button></td>
          <td><button class="btn btn-xs" @click="openView('실패 내용', r.failReason)">보기</button></td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="14" class="empty">조회된 이력이 없습니다.</td>
        </tr>
      </tbody>
    </table>

    <Paging :page="paging.page" :size="paging.size" :total-count="paging.totalCount"
            :total-pages="paging.totalPages" @change-page="onPage" @change-size="onSize" />

    <div v-if="viewPopup.show" class="modal-mask" @click.self="viewPopup.show=false">
      <div class="modal-box">
        <h4>{{ viewPopup.title }}</h4>
        <textarea class="view-area" readonly :value="viewPopup.content"></textarea>
        <div class="modal-foot"><button class="btn" @click="viewPopup.show=false">닫기</button></div>
      </div>
    </div>

    <div v-if="dlPopup" class="modal-mask" @click.self="dlPopup=false">
      <div class="modal-box dl-box">
        <h4>기간 내 발송성공건 다운로드</h4>
        <div class="dl-row"><label>발송일 시작</label><input type="date" v-model="dl.startDt" class="ed" /></div>
        <div class="dl-row"><label>발송일 끝</label><input type="date" v-model="dl.endDt" class="ed" /></div>
        <div class="dl-foot"><button class="btn btn-primary" @click="doDownload">다운로드</button></div>
      </div>
    </div>
  </div>
</template>

<script>
import XLSXStyle from 'xlsx-js-style';   // 29007: 엑셀(.xlsx) 생성을 프론트에서 수행(서버 POI 제거)
import api from '../api';
import Paging from '../components/Paging.vue';

export default {
  name: 'SmsHistView',
  components: { Paging },
  data() {
    return {
      filters: { phone: '', startDt: '', endDt: '', msgType: '', sendResult: '' },
      rows: [],
      sel: {},
      paging: { page: 1, size: 10, totalCount: 0, totalPages: 0 },
      viewPopup: { show: false, title: '', content: '' },
      dlPopup: false,
      dl: { startDt: '', endDt: '' }
    };
  },
  computed: {
    allChecked() {
      return this.rows.length > 0 && this.rows.every(r => this.sel[r.id]);
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      const params = {
        phone: this.filters.phone || undefined,
        startDt: this.filters.startDt || undefined,
        endDt: this.filters.endDt || undefined,
        msgType: this.filters.msgType || undefined,
        sendResult: this.filters.sendResult || undefined,
        page: this.paging.page,
        size: this.paging.size
      };
      try {
        const res = await api.smsHistList(params);
        const d = res.data || {};
        this.rows = d.list || [];
        this.paging.totalCount = d.totalCount || 0;
        this.paging.totalPages = d.totalPages || 0;
        this.sel = {};
      } catch (e) {
        alert(e.message || '조회 실패');
      }
    },
    onSearch() { this.paging.page = 1; this.load(); },
    onPage(p) { this.paging.page = p; this.load(); },
    onSize(s) { this.paging.size = s; this.paging.page = 1; this.load(); },
    toggleAll(e) {
      const v = e.target.checked;
      const next = {};
      this.rows.forEach(r => { next[r.id] = v; });
      this.sel = next;
    },
    resultLabel(v) {
      if (v === 'S' || v === 'Y') return '성공';
      if (v === 'F') return '실패';
      return '-';
    },
    msgLabel(v) {
      // 29003: L=LMS, S=SMS, 빈값=-
      if (v === 'L') return 'LMS';
      if (v === 'S') return 'SMS';
      return '-';
    },
    openView(title, content) {
      this.viewPopup = { show: true, title, content: content || '' };
    },
    async downloadSearch() {
      // 29007: 검색결과 다운로드. 서버는 검색조건 전체 건(JSON)만 반환, .xlsx 는 프론트에서 생성.
      //  컬럼/열너비/정렬은 기존 서버(POI) 출력과 동일. 일시(22)·전화번호(18)·이름(25)·메시지종류(18)·발송결과(18)·발송내용(100)
      //  2행부터 일시·메시지종류(0,3) 중앙, 나머지 좌측.
      try {
        const res = await api.smsHistSearchRows({
          phone: this.filters.phone || undefined,
          startDt: this.filters.startDt || undefined,
          endDt: this.filters.endDt || undefined,
          sendResult: this.filters.sendResult || undefined
        });
        const data = res.data || [];
        const headers = ['일시', '전화번호', '이름', '메시지 종류', '발송결과', '발송 내용'];
        const keys = ['sendDt', 'telTo', 'name', 'msgType', 'sendResult', 'msgContent'];
        const widths = [22, 18, 25, 18, 18, 100];
        this.buildAndSaveXlsx('검색결과', headers, keys, data, widths, [0, 3], 'sms_search_result.xlsx');
      } catch (err) { alert(err.message || '다운로드에 실패했습니다.'); }
    },
    // 29007: 공통 .xlsx 생성(서식 = 기존 POI 출력 재현). centerCols = 2행부터 중앙정렬할 열 인덱스, 그 외 좌측.
    buildAndSaveXlsx(sheetName, headers, keys, rows, widths, centerCols, filename) {
      const aoa = [headers.slice()];
      rows.forEach(r => aoa.push(keys.map(k => (r[k] == null ? '' : String(r[k])))));
      const ws = XLSXStyle.utils.aoa_to_sheet(aoa);
      ws['!cols'] = widths.map(w => ({ wch: w }));

      const FONT = { name: '맑은 고딕' };
      const BORD = { style: 'thin', color: { rgb: '808080' } };   // 어두운 회색(GREY_50_PERCENT 상당)
      const border = { top: BORD, bottom: BORD, left: BORD, right: BORD };
      const headStyle = { font: Object.assign({ bold: true }, FONT),
                          alignment: { horizontal: 'center', vertical: 'center' },
                          fill: { patternType: 'solid', fgColor: { rgb: 'C0C0C0' } },   // 밝은 회색(GREY_25_PERCENT 상당)
                          border };
      const centerStyle = { font: FONT, alignment: { horizontal: 'center', vertical: 'center' }, border };
      const leftStyle   = { font: FONT, alignment: { horizontal: 'left',   vertical: 'center' }, border };

      const centerSet = {};
      centerCols.forEach(c => { centerSet[c] = true; });
      const totalRows = rows.length + 1;   // 헤더 1행 + 데이터
      for (let r = 0; r < totalRows; r++) {
        for (let c = 0; c < headers.length; c++) {
          const addr = XLSXStyle.utils.encode_cell({ r, c });
          if (!ws[addr]) ws[addr] = { t: 's', v: '' };
          ws[addr].s = (r === 0) ? headStyle : (centerSet[c] ? centerStyle : leftStyle);
        }
      }

      const wb = XLSXStyle.utils.book_new();
      XLSXStyle.utils.book_append_sheet(wb, ws, sheetName);
      XLSXStyle.writeFile(wb, filename);
    },
    todayIso() {
      const t = new Date();
      const mm = String(t.getMonth() + 1).padStart(2, '0');
      const dd = String(t.getDate()).padStart(2, '0');
      return `${t.getFullYear()}-${mm}-${dd}`;
    },
    openDownload() {
      const iso = this.todayIso();
      this.dl = { startDt: iso, endDt: iso };
      this.dlPopup = true;
    },
    async doDownload() {
      const s = this.dl.startDt, e = this.dl.endDt;
      if (!s || !e) { alert('발송일 시작과 끝을 선택하세요.'); return; }
      if (s > e) { alert('발송일 끝이 시작보다 빠를 수 없습니다.'); return; }
      const sd = new Date(s + 'T00:00:00');
      const limit = new Date(sd); limit.setFullYear(limit.getFullYear() + 1);
      const ed = new Date(e + 'T00:00:00');
      if (ed >= limit) { alert('범위는 1년 이하로 설정하세요'); return; }
      try {
        // 29007: 기간 내 발송성공건. 서버는 JSON 행만 반환, .xlsx 는 프론트에서 생성.
        //  컬럼: 발송일시(22)·전화번호(18)·이름(30)·메시지종류(18)·발송내용(100). 2행부터 발송일시(0)만 중앙, 나머지 좌측.
        const res = await api.smsHistSuccessRows({ startDt: s, endDt: e });
        const data = res.data || [];
        const headers = ['발송 일시', '전화번호', '이름', '메시지 종류', '발송 내용'];
        const keys = ['sendDt', 'telTo', 'name', 'msgType', 'msgContent'];
        const widths = [22, 18, 30, 18, 100];
        this.buildAndSaveXlsx('발송내역', headers, keys, data, widths, [0],
          `sms_send_${s.replace(/-/g, '')}_${e.replace(/-/g, '')}.xlsx`);
        this.dlPopup = false;
      } catch (err) {
        alert(err.message || '다운로드에 실패했습니다.');
      }
    }
  }
};
</script>

<style scoped>
.sms-hist { background: #fff; padding: 18px; border-radius: 8px; }
h3 { margin: 0 0 14px; font-size: 18px; }
.toolbar { display: flex; gap: 10px; align-items: center; margin-bottom: 12px; flex-wrap: wrap; }
.tb-left { display: flex; gap: 6px; align-items: center; flex-wrap: wrap; }
.tilde { color: #888; }
.ed { padding: 6px 8px; border: 1px solid #d0d5dd; border-radius: 5px; font-size: 13px; }
.ed-sm { width: 130px; }
.btn { padding: 6px 12px; border: 1px solid #c3cad6; background: #f4f6fa; border-radius: 5px; cursor: pointer; font-size: 13px; }
.btn:hover { background: #e9edf4; }
.btn-primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.btn-primary:hover { background: #255fd0; }
.btn-xs { padding: 3px 8px; font-size: 12px; }
.grid { width: 100%; border-collapse: collapse; font-size: 13px; }
.grid th, .grid td { border: 1px solid #e3e7ef; padding: 7px 8px; text-align: center; white-space: nowrap; }
.grid th { background: #f3f5f9; font-weight: 600; }
.empty { color: #888; padding: 18px 0; }
.c-red { color: #d64545; }
.c-green { color: #1b8a3a; }
.modal-mask { position: fixed; inset: 0; background: rgba(20,28,48,0.35); display: flex; align-items: center; justify-content: center; z-index: 9000; }
.modal-box { background: #fff; border-radius: 10px; padding: 18px 20px; min-width: 360px; max-width: 90vw; max-height: 85vh; overflow: auto; box-shadow: 0 8px 30px rgba(0,0,0,0.25); }
.modal-box h4 { margin: 0 0 12px; }
.view-area { width: 100%; min-width: 320px; height: 140px; border: 1px solid #d0d5dd; border-radius: 6px; padding: 8px; font-size: 13px; resize: none; }
.modal-foot { text-align: right; margin-top: 12px; }
.tb-right { margin-left: auto; display: flex; gap: 6px; align-items: center; }
.dl-box { min-width: 300px; }
.dl-row { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; }
.dl-row label { width: 76px; color: #444; font-size: 13px; }
.dl-row .ed { flex: 1; }
.dl-foot { text-align: center; margin-top: 14px; }
</style>
